module.exports = __webpack_public_path__ + "img/user.9ca7b8bd.svg";